import Cookies from 'js-cookie';
import apiSlice from './apiSlice';

const apiSliceWithTag = apiSlice.enhanceEndpoints({ addTagTypes: ['ReviewsReports'] });

const apiReviewsReportsSlice = apiSliceWithTag.injectEndpoints({
  endpoints: (builder) => ({
    listReviewAbuseReports: builder.query({
      query: ({ ean, reviewId }) => ({
        url: `/community/products/${ean}/reviews/${reviewId}/abuse/`,
      }),
      providesTags: (result, error, arg) => [{ type: 'ReviewsReports', id: arg.reviewId }],
    }),
    createReviewAbuseReport: builder.mutation({
      query: ({ ean, reviewId, payload }) => ({
        url: `/community/products/${ean}/reviews/${reviewId}/abuse/`,
        method: 'POST',
        body: payload,
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': Cookies.get('csrftoken'),
        },
      }),
      invalidatesTags: (result, error, arg) => [{ type: 'ReviewsReports', id: arg.reviewId }],
    }),
    retrieveReviewAbuseReport: builder.query({
      query: ({ ean, reviewId, id }) => ({
        url: `/community/products/${ean}/reviews/${reviewId}/abuse/${id}`,
      }),
      providesTags: (result, error, arg) => [{ type: 'ReviewsReports', id: arg.reviewId }],
    }),
    partialUpdateReviewAbuseReport: builder.mutation({
      query: ({ ean, reviewId, id, note }) => ({
        url: `/community/products/${ean}/reviews/${reviewId}/abuse/${id}`,
        method: 'PATCH',
        body: { note },
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': Cookies.get('csrftoken'),
        },
      }),
      invalidatesTags: (result, error, arg) => [{ type: 'ReviewsReports', id: arg.reviewId }],
    }),
    destroyReviewAbuseReport: builder.mutation({
      query: ({ ean, reviewId, id }) => ({
        url: `/community/products/${ean}/reviews/${reviewId}/abuse/${id}`,
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': Cookies.get('csrftoken'),
        },
      }),
      invalidatesTags: (result, error, arg) => [{ type: 'ReviewsReports', id: arg.reviewId }],
    }),
  }),
});

export const { useListReviewAbuseReportsQuery, useCreateReviewAbuseReportMutation, useRetrieveReviewAbuseReportQuery, usePartialUpdateReviewAbuseReportMutation, useDestroyReviewAbuseReportMutation } = apiReviewsReportsSlice;

export default apiReviewsReportsSlice;
